import React, { useEffect, useRef, useState } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { getEvent } from "../../services/clients";
import { getDuration } from "../../utils/utils";

DataTable.use(DT);

const ViewEventsModal = NiceModal.create(
  ({ session_id, email, username, duration, platform }) => {
    const [event, setEvent] = useState(null);
    const eventTableRef = useRef(null);
    const [eventTableData, setEventTableData] = useState([]);
    const modal = useModal();

    useEffect(() => {
      if (session_id) {
        getEvent(session_id).then((events) => {
          console.log("!!! event: ", event);

          setEvent(events);
          const eventData = events.map((event) => {
            return [
              event.public_id,
              event.event,
              event.data,
              event.event_date ? new Date(event.event_date) : "",
            ];
          });
          setEventTableData(eventData);
        });
      }
      // eslint-disable-next-line
    }, [session_id]);

    const hide = (e) => {
      modal.remove();
    };

    return (
      <>
        <div className="w-5/12 h-auto force-height-90 force-center items-center flex overflow-x-hidden overflow-y-hidden overflow-hidden fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative w-full my-6 mx-auto max-w-3xl">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                <h3 className="text-3xl font-semibold">
                  {"Events for " + username} ({email}){" "}
                </h3>
              </div>
              <div
                className="relative p-6 flex-auto overflow-y-auto"
                style={{ maxHeight: "70vh" }}
              >
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                  Session ID: {session_id}
                </div>
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                  Platform: {platform}
                </div>
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                  Duration: {duration}
                </div>
                <DataTable
                  ref={eventTableRef}
                  data={eventTableData}
                  className="display"
                  options={{
                    responsive: true,
                    select: true,
                    pageLength: 25,
                    order: [[3, "desc"]],
                  }}
                >
                  <thead>
                    <tr>
                      <th>Public ID</th>
                      <th>Event</th>
                      <th>Data</th>
                      <th>Event Date</th>
                    </tr>
                  </thead>
                </DataTable>
              </div>
              <div className="relative p-6 flex-auto"></div>
              <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                <button
                  className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  type="button"
                  onClick={hide}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      </>
    );
  }
);

NiceModal.register("view-events", ViewEventsModal);

const EventsTable = ({ events = [], onUpdated = () => {} }) => {
  const tableRef = useRef(null);

  window.view = (session_id, email, username, duration, platform) => {
    console.log("!!! EVENT: ", session_id);
    NiceModal.show("view-events", {
      session_id,
      email,
      username,
      duration,
      platform,
    });
  };

  const tableData = events.map((event) => {
    const duration = getDuration(event.latest_event, event.first_event);
    return [
      event.session_id,
      event.user_group,
      event.email,
      event.user,
      event.platform,
      event.event_count,
      event.first_event ? new Date(event.first_event) : "",
      event.latest_event ? new Date(event.latest_event) : "",
      duration,
      `<div style="display: flex; flex-direction: row;"><div style="display: flex; flex-direction: row;"><button style="width: 50px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 14px; color: black;" onClick="window.view('${event.session_id}', '${event.email}', '${event.user}', '${duration}', '${event.platform}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">View</button></div></div>`,
    ];
  });

  return (
    <div>
      <div style={{ fontSize: "32px", fontWeight: "bold" }}>
        Event Sessions ({events.length})
      </div>
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
          order: [[6, "desc"]],
        }}
      >
        <thead>
          <tr>
            <th>Session ID</th>
            <th>Group</th>
            <th>Email</th>
            <th>User</th>
            <th>Platform</th>
            <th>Event Count</th>
            <th>First Event</th>
            <th>Latest Event</th>
            <th>Duration</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default EventsTable;
